var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBelgium = function SvgBelgium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Belgium_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Belgium_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Belgium_svg__f",
    cx: -120,
    cy: 100.2,
    r: 98.1,
    transform: "rotate(-45 -119.994 100.203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Belgium_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Belgium_svg__f",
    cx: 100,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.031 100.266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Belgium_svg__d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Belgium_svg__f",
    cx: 321.4,
    cy: 100.1,
    r: 97.7,
    transform: "rotate(-80.8 321.313 100.13)"
  })), /*#__PURE__*/React.createElement("style", null, ".Belgium_svg__f{stroke-width:0;fill:none}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Belgium_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e41e26",
      strokeWidth: 0
    },
    d: "M-256.4 2.1H37.9v196.2h-294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fed500",
      strokeWidth: 0
    },
    d: "M-256.4 51.2H37.9v98.1h-294.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.031 100.266)",
    style: {
      stroke: "#a5a7aa",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Belgium_svg__c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      fill: "#171715"
    },
    d: "M2.6 2.8h194.8v194.7H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fedd1c",
      strokeWidth: 0
    },
    d: "M67.5 2.8h64.9v194.7H67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed2024",
      strokeWidth: 0
    },
    d: "M132.5 2.8h64.9v194.7h-64.9z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Belgium_svg__f",
    cx: 100,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.031 100.266)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Belgium_svg__d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d91f26",
      strokeWidth: 0
    },
    d: "M175 2.6h293v195.3H175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 2.6h43.9l102.5 94.2L424 2.6h43.9L175 197.9h43.9l102.5-94.2 102.5 94.2h43.9L175 2.6Zm292.9 78.1v39.1l-293-39.1v39.1l293-39.1ZM306.8 2.6l14.6 83.7 14.7-83.7h-29.3Zm0 195.3 14.6-83.7 14.7 83.7h-29.3Z",
    style: {
      fill: "#fee600",
      strokeWidth: 0
    }
  })));
};
export default SvgBelgium;